import React, { Component } from 'react';
import './App.scss';
import FingerprintJS from '@fingerprintjs/fingerprintjs-pro';
import axios from './axios-instance';
import { withRouter } from 'react-router';
import Loader from './components/UI/Loader/Loader';
import moment from 'moment';
import ContentDetails from './components/ContentDetails/ContentDetails';
import actv8Logo from './images/actv8me-logo.png'
import Button from './components/UI/Button/Button';
import scratchImage from './images/swipe-to-reveal-v2.png';
import Wallet from './components/Wallet/Wallet';
import Error from './components/UI/Error/Error';
import ReactGA from 'react-ga4';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';

class App extends Component {

  static propTypes = {
    cookies : instanceOf(Cookies).isRequired
  }

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      deviceId: '',
      device: {
        uuid: null,
        latitude: '', 
        longitude: '',
        locale: '',
        manufacturer: '',
        model: '',
        os_name:'',
        os_version: '',
      },
      triggerId: '',
      id: null,
      hero: null,
      title: null,
      brand: null,
      description: null,
      buyOnline: null,
      contentTermId: null,
      contentTerms: '',
      endDate: null,
      buyInStore: null,
      content: null,
      showBuyInStore: false,
      toggleTerms: false,
      type: null,
      showContent: false,
      jwt:'',
      androidPass: false,
      terms: '',
      isMobile: null,
      isIphone: null,
      showActv8: false,
      geolocation: false,
      fetchLocation: null,
      showScratcherOverlay: null,
      scratcherOverlayImage: null,
      applePass: false,
      showWallet: false,
      showDownload: false,
      buyNowText: 'Buy Now',
      buyInStoreText: 'Buy In-Store',
      showError: false,
      status: null,
      hasSlug: null,
      catchUrlSearch: null,
      gdpr: null,
      gdpr_consent : null,
      clickThroughBtn1 : null,
      clickThroughBtn2 : null,
      forwardParams : null,
      showLoader : false,
      loadStartTime : null,
      totalLoadTime : null,
      totalLoatTimeEventSent : false,
      timedOut : false
    }
  }

  componentDidMount() {
    const cookieEnabled = navigator.cookieEnabled;
    console.log('cks nabd : ' + cookieEnabled);

    if(window.location.pathname === '/sweepstakes-rules') {
      window.location.replace('https://actv8me-public-assets-production.s3.amazonaws.com/downloadable/tpn/FINAL_TPN_Oikos_Family_Reunion_Promotion_Official_Rules_11_03_22.pdf');
      return;
    };

    if(process.env.REACT_APP_GOOGLE_ANALYTICS_PROPERTY_ID !== undefined && process.env.REACT_APP_GOOGLE_ANALYTICS_PROPERTY_ID !== null){
      ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_PROPERTY_ID);
      ReactGA.send('pageview');
    }

    // Set start time
    this.loadStartTime = Date.now();
    const timeOutValue = (process.env.REACT_APP_TIMEOUT_VALUE !== undefined && process.env.REACT_APP_TIMEOUT_VALUE !== null) ? process.env.REACT_APP_TIMEOUT_VALUE : 15000;

    setTimeout(() => {
      if(this.state.loading === true) {
        // Record time after getting device details / posting uuid
        this.setState({
          timedOut : true,
          totalLoadTime : Date.now() - this.loadStartTime
        });
        this.showError(408);
      }      
    }, timeOutValue);

    // Check slug
    this.checkSlug();
  }

  async checkSlug() {
    console.log('Checking slug...');
    let paramsString = this.props.location.search;
    const params = new URLSearchParams(paramsString);

    if(params.has('gdpr') && params.has('gdpr_consent')) {
      this.setState({
        gdpr: params.get('gdpr'),
        gdpr_consent: params.get('gdpr_consent'),
      })      
    }

    if (params.has('sl')) {
      this.setState({hasSlug: true});
      const res = await axios.get(`/shortlink?slug=${params.get('sl')}`); 

      if (res && res.data) {
        let search = new URL(res.data.url).search;
        this.setState({catchUrlSearch: search});
      } else {          
        this.showError(404);
      }
    } else {
      this.setState({hasSlug: false});
    }

    this.extractForwardParams(params);

  }

  extractForwardParams (params){
    // Remove ACTV8 params
    params.delete('sl');
    params.delete('geolocation');
    
    // Set forward params with non-actv8 params
    this.setState({forwardParams:params.toString()});
    this.getDeviceDetails();
  }

  checkParams = (res) => {
    console.log('checking  params...');
    const paramsString = window.location.search;

    const params = new URLSearchParams(paramsString);
    
    if (!params.has('sl') && (!params.has('triggerable_id') || !params.has('client_id'))) {
      this.setState({
        showWallet: true
      })
    } else {
      this.getTriggerId(res.data.id);
      this.setState({
        showWallet: false
      })
    }
  }

  mobileCheck = () => {
    let check = false;
    // eslint-disable-next-line
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  }

  getDeviceDetails = () => {
    const {cookies} = this.props;

    let agent = navigator.userAgent.toLowerCase();
    let deviceToUpdate = {...this.state.device};
    deviceToUpdate.uuid = cookies.get('a8FpVid');
    deviceToUpdate.os_name = this.props.ua.os.name;
    deviceToUpdate.os_version = this.props.ua.os.version;
    deviceToUpdate.manufacturer = this.props.ua.device.vendor;
    deviceToUpdate.model = this.props.ua.device.model;
    deviceToUpdate.locale = navigator.language || 'en-US';
    let isIphone = agent.indexOf("iphone") > -1;
    let isMobile = this.mobileCheck(); 
    this.setState({
      isMobile: isMobile,
      isIphone: isIphone
    });
    
    const params = new URLSearchParams(this.props.location.search);
    let geolocationEnabled = false; 
    params.forEach((value, key) => {
      if(key === 'geolocation' && value === 'true') {
        geolocationEnabled = true;
      }
    })

    if(deviceToUpdate.uuid) {
      console.log('UUID retrieved from ck'); 
      this.setState({device: deviceToUpdate});
      geolocationEnabled ? this.getLocation(deviceToUpdate) : this.updateDevice(deviceToUpdate);
    } else {
      this.getUuid(deviceToUpdate, geolocationEnabled);
    }         
  }

  getUuid = async(deviceToUpdate, geolocationEnabled) => {
    console.log('ck not found. Getting fp...');
    const {cookies} = this.props;

    let fpPromiseParams = {token: process.env.REACT_APP_FPJS_TOKEN}
    
    if(process.env.REACT_APP_FPJS_ENDPOINT !== null) {
      fpPromiseParams.endpoint = process.env.REACT_APP_FPJS_ENDPOINT;
    } else {
      console.log('Missing fp endpoint')
      return;
    }

    const fpPromise = FingerprintJS.load(fpPromiseParams);
    
    try {
      const fp = await fpPromise;
      const result = await fp.get();
      if(result.visitorId) {
        deviceToUpdate.uuid = result.visitorId;
        let cookieMaxAge = process.env.REACT_APP_FPJS_COOKIE_MAX_AGE_DAYS ? process.env.REACT_APP_FPJS_COOKIE_MAX_AGE_DAYS * (60 * 60 * 24) : 300; // (60 seconds * 60 minutes * 24 hours)             
        this.setState({device: deviceToUpdate});
        cookies.set('a8FpVid', deviceToUpdate.uuid, {maxAge: cookieMaxAge , path: '/', sameSite: true}); 
        geolocationEnabled ? this.getLocation(deviceToUpdate) : this.updateDevice(deviceToUpdate);
      } else {
        console.log('Device fp could not be retrieved');
      }
    } catch (error) {
      let message = error.message || '';
      console.log('Error: ', message);
    }      
  }

  updateDevice = async(device) => {
    try {
      let endpoint = `device/${device.uuid}`;
      if(this.state.gdpr){
        endpoint += `?gdpr=${this.state.gdpr}`;
        endpoint += `&gdpr_consent=${this.state.gdpr_consent}`;
      }

      const res = await axios.put(endpoint, device, {
        headers: {
            'x-device-uuid': `${device.uuid}`
        }
      });
      if (res && res.data) {
        this.setState({
          deviceId: res.data.id,
          device: res.data
        });
        this.checkParams(res);
      }
    } catch(err) {      
      if(err.message === 'Request failed with status code 403') {
        this.showError(403);
      } else {
        this.showError(err.status);
      }
      
      console.error('ERROR: ', err.message);
    }
  }

  onRedirectUrl = (url) => {
    let newUrl;
    newUrl = url.replace('?a8_redirect=1', '');
    newUrl = newUrl.replace('?a8_redirect=0', '');
    newUrl = newUrl.replace('&a8_redirect=1', '');
    newUrl = newUrl.replace('&a8_redirect=0', '');
    window.location.href = newUrl;
  }

  updateStatus = async (status, content) => {
    try {
        const uri = `/device/${this.state.device.uuid}/content/${content.id}?status=${status}`;
        const res = await axios.put(uri, {}, {
            headers: {
            'Content-Type': 'application/json',
            'x-device-uuid': `${this.state.device.uuid}`
            }
        });
        if (res && res.status === 200) {
            if (res.data && res.data.message) {
                console.log('STATUS: ', status + ' ', res.data.message);
            }
        }
        this.onRedirectUrl(content.url)
    } catch (err) {
        this.onRedirectUrl(content.url)
        console.error('Error: ', err);
    }
  };

  getLongUrl = (slug) => {
    console.log('getting long url');
    try {
      axios.get(`/shortlink?slug=${slug}`).then((res) => {
        if (res && res.data) {
          let search = new URL(res.data.url).search;
          this.setState({catchUrlSearch: search});
        } else {          
          this.showError(404);
        }
      });
    } catch (err) {
      console.error(err)
      this.showError(err.status)
    }
  }

  getTriggerId = (deviceId) => {
    console.log('getting trigger id ');
    console.log('has slug? ' + this.state.hasSlug);
    console.log('location search: ' + this.props.location.search);
    
    let paramsString = this.state.hasSlug ? this.state.catchUrlSearch : this.props.location.search;
    // console.log('Params string: ' + paramsString);

    const params = new URLSearchParams(paramsString);
    if (params.has('triggerable_id') && params.has('client_id') && params.has('triggerable_type')) {
      let triggerable_id = params.get('triggerable_id');
      let triggerable_type = params.get('triggerable_type');;
      let client_id = params.get('client_id');
      if (triggerable_type && triggerable_type !== null && triggerable_id && triggerable_id !== null && client_id && client_id !== null) {      
        this.catchContentByTriggerType(triggerable_type, triggerable_id, this.state.deviceId, client_id);
      } 
    } else if(params.has('trigger_uuid')){
      console.log('trigger by uuid');
      const trigger_uuid = params.get('trigger_uuid');
      this.catchContentByTriggerUuid(trigger_uuid);
    } else {
      console.log('Missing params...');
    }      
  }

  catchContentByTriggerType = async(triggerable_type, triggerable_id, deviceId, client_id) => {
      const res = await axios.post(`${triggerable_type}/${triggerable_id}/catch?client_id=${client_id}`, {}, {
        headers: {
            'x-device-uuid': `${this.state.device.uuid}`
        }
      });
      this.catchContent(res, deviceId);
  }

  catchContentByTriggerUuid = async(trigger_uuid, deviceId) => {
    const res = await axios.post(`content/deliver?trigger_uuid=${trigger_uuid}`, {}, {
      headers: {
          'x-device-uuid': `${this.state.device.uuid}`
      }
    });
    this.catchContent(res, deviceId);
  }

  catchContent(res, deviceId){
    try {
      if (res && res.data && res.data[0]) {
        if (res.data[0].type === 'offer' || res.data[0].type === 'prize' || res.data[0].type === 'message') {
          this.checkScratcher(res.data[0]);
          this.setContentItem(res.data[0], deviceId);	
        } else if (res.data[0].type === 'url') {
          const parsedContentUrl = new URL(res.data[0].url);
          if (parsedContentUrl.searchParams.has('a8_redirect')) {
             if (Number(parsedContentUrl.searchParams.get('a8_redirect')) === 1) {
               this.updateStatus(1, res.data[0])
             } else {
               this.showError();
             }
          } else {
            this.checkScratcher(res.data[0]);
            this.setContentItem(res.data[0], deviceId);	
            //this.showError();
          }
        } else {
          this.showError();
        }
      } else {
        this.showError(res.status);
      }
    } catch(err) {
      console.error('Error: ', err);
      if (err.message) {
        this.showError(err.message)
      } else {
        this.showError();
      }
    }
  }

  showError = (status) => {    
    this.setState({showError: true, loading: false, status: status});
  }

  checkScratcher(data) {
    if (data.scratcher && data.scratcher.enabled) {
      let scratcherImage = data.scratcher.images && data.scratcher.images.overlay && data.scratcher.images.overlay.url ? this.getCdnPath(data.scratcher.images.overlay.url) : scratchImage;
      //let scratcherImage = data.scratcher.images && data.scratcher.images.overlay && data.scratcher.images.overlay.url ? data.scratcher.images.overlay.url : scratchImage;
      this.setState({
        showScratcherOverlay: true,
        scratcherOverlayImage: scratcherImage
      });
    } else {
      this.setState({
        showScratcherOverlay: false
      });
    }
  }
  
  setContentItem(content, deviceId) {
    let end;
    let isBuyInStore;
    let tandc = 'Terms & Conditions';
    let exp = 'Expired';
    let termID = content.content_term_id;
    let showDownload = false;

    if (content.buttons && content.buttons.length > 0) {
      const buttons = content.buttons.slice();
      const buyNowButtons = buttons.filter(button => button.key === 'redeem_online_btn' && button.locale === 'en');
      const buyInStoreButton = buttons.filter(button => button.key === 'redeem_in_store_btn' && button.locale === 'en');
      const clickThroughBtn1 = buttons.filter(button => button.key === 'click_through_btn_1' && button.locale === 'en');
      const clickThroughBtn2 = buttons.filter(button => button.key === 'click_through_btn_2' && button.locale === 'en');

      if (buyNowButtons && buyNowButtons.length > 0) {
        this.setState({buyNowText: buyNowButtons[0].label})
      }
      if (buyInStoreButton && buyInStoreButton.length > 0) {
        this.setState({buyInStoreText: buyInStoreButton[0].label});
      }
      if (clickThroughBtn1 && clickThroughBtn1.length > 0) {
        console.log(clickThroughBtn1[0]);
        this.setState({clickThroughBtn1: clickThroughBtn1[0]});
      }
      if (clickThroughBtn2 && clickThroughBtn2.length > 0) {
        this.setState({clickThroughBtn2: clickThroughBtn2[0]});
      }

    }

    if (content.redemption !== null) {
        if ((content.redemption.method === 2 || content.redemption.method === 3)) {
            isBuyInStore = true;
        } else if (content.redemption.method === 1 && content.redemption.url) {
          let url = new URL(content.redemption.url).search.split('&');
          let isDownload = url[0].split('?action=').join('') === 'download'
          showDownload = isDownload;
        } else {
            isBuyInStore = false;
        }
    } else {
        isBuyInStore = false;
    }

    if (content.end_at === null || content.end_at === undefined) {
      end = 'Never'
    } else {
      let endAt = moment(content.end_at);
      end =  endAt.isBefore(moment()) ? exp : endAt.from(moment());
    }

    // Set redemption URL
    let redemptionURL = content.redemption && content.redemption !== null && content.redemption.url ? content.redemption.url  : '';

    // Appends forward params (i.e. macros) based on env setting 
    if(redemptionURL !== '' && process.env.REACT_APP_FORWARD_PARAMS === 'true') {
      redemptionURL += redemptionURL.indexOf('?') > -1 ? '&' : '?';
      redemptionURL += this.state.forwardParams;
    }

    this.setState({
        id: content.id,
        hero: this.getCdnPath(content.images.hero.url),
        title: content.display_name,
        brand: content.brand,
        description: content.description,
        buyOnline: redemptionURL,
        contentTermId: termID || '',
        contentTerms: tandc,
        endDate: end,
        buyInStore: isBuyInStore,
        showBuyInStore: false,
        toggleTerms: false,
        type: content.type,
        showContent: true,
        content: content,
        applePass: content.apple_pass_enabled,
        showDownload: showDownload
    });
    
    if (termID && termID !== null) {
        this.getContentTerms(termID);
    }

    if (content.android_pass_enabled) {
      this.postAndroidPass(content.id, deviceId);
    } else {
      this.setState({
        loading: false
      });
    }
  }

  getContentTerms = async(id) => {
    try {
      let res = await axios.get(`content-terms/` + id, {
        headers: {
          'x-device-uuid': `${this.state.device.uuid}`
        }
      })
      if (res) {
        let terms = String(res.data.body);
        this.setState({terms: terms})
      }
    } catch (err) {
      console.log('Error: ', err)
    }
  }

  postAndroidPass = async(id, deviceId) => {
    try {
        const res = await axios.post(`/device/${this.state.device.id}/content/${id}/androidpass`, {
          "forward_url_params" : this.state.forwardParams
        } ,{
          headers: {
            'x-device-uuid': `${this.state.device.uuid}`,                
          }
        });
        if (res) {
            this.setState({
                androidPass: true,
                jwt: res.data.jwt.jwt,
                loading: false
            })
        }
    } catch(err) {
        console.log('Error :', err);
        this.setState({
            loading: false
        });
    }
  }

  onToggleTerms = () => {
    this.setState({
        contentTerms: this.state.contentTerms === 'Terms & Conditions' ? this.state.terms : 'Terms & Conditions'
    });
  }
  noThanksHandler = () => {
    this.setState({showActv8: true})
  }
  goBackHandler = () => {
    this.setState({showActv8: false})
  }

  getLocation(device) {
    if (!('geolocation' in navigator)) {
      console.log('geolocation not available');
        return;
    }
    navigator.geolocation.getCurrentPosition(
        (position) => {          
          device.latitude = position.coords.latitude;
          device.longitude = position.coords.longitude;

          this.setState({
            device: device,
            fetchedLocation: position,
            loading: false,
          })
          
          this.updateDevice(device)
        },
        (err) => {
            console.log(err);
            this.setState({
                fetchedLocation: null,
                loading: false
            })
        },
        //{timeout: 7000}
    )
  }

  getCdnPath(url) {
    return url.replace("https://s3.amazonaws.com/cdn.actv8me.com/", "https://cdn.actv8me.com/");
  }

  postLoadTime = async() => {
    if(this.state.totalLoatTimeEventSent === true) {
      return;
    }

    const action = this.state.timedOut === true ? "Timed Out" : 'Page Load Time'
    const event = {
      category: "Site Action",
      subcategory: "Performance",
      action: action,
      label: this.totalLoadTime,
    } 

    event.client_id = this.state.content?.client_id?? null;
    event.campaign_id = this.state.content?.pivot?.campaign_id?? null;
    event.trigger_id = this.state.content?.pivot?.trigger_id?? null;
    event.content_id = this.state.content?.pivot?.content_id?? null;

    try {
      const res = await axios.post(`/event`, event, {
        headers: {
          'x-device-uuid': `${this.state.device.uuid}`,
        }
      });
      if (res && res.data) {
        console.log('Event tracked', res.data);
        this.setState({
          totalLoatTimeEventSent : true,
        });
      }
    } catch(err) {
      console.error('Error: ', err);
    }
  }

  render() {
    const loader = (
      <div className="LoadContainer" >
          <div className="Loading">
            <Loader />
          </div>
      </div>
    );

    const contentDetails = (
      <ContentDetails 
        open={true}
        content={this.state.content}
        closePreview={this.toggleClose}
        hero={this.state.hero}
        buyOnline={this.state.buyOnline}
        title={this.state.title}
        brand={this.state.brand}
        description={this.state.description}
        hasTerms={this.state.terms && this.state.terms !== ''}
        date={this.state.endDate}
        showBuyInStore={this.state.buyInStore}
        toggleTerms={this.onToggleTerms}
        terms={this.state.terms}
        onBuyInStore={this.handleBuyInStore}
        onNoThanks={this.noThanksHandler}
        type={this.state.type}
        onClaimPrize={this.toggleClose}
        androidPass={this.state.androidPass}
        applePass={this.state.applePass}
        jwt={this.state.jwt}
        isMobile={this.state.isMobile}
        isIphone={this.state.isIphone}
        deviceId={this.state.deviceid}
        device={this.state.device}
        scratcher={this.state.showScratcherOverlay}
        scratcherOverlayImage={this.state.scratcherOverlayImage}
        showDownload={this.state.showDownload}
        buyNowText={this.state.buyNowText}
        buyInStoreText={this.state.buyInStoreText}
        clickThroughBtn1={this.state.clickThroughBtn1}
        clickThroughBtn2={this.state.clickThroughBtn2}
        forwardParams={this.state.forwardParams}
        />
    );

    return (
      <div className="App"> 
        {
          this.state.showWallet ? <Wallet device={this.state.device}/> : this.state.showError ? <Error status={this.state.status} /> : (
            <div>
            { this.state.loading || this.state.showScratcherOverlay === null ? loader : (
              <div>
                { this.state.showActv8 ? 
                  <div>
                    <div className="LogoContainer">
                      <img className="Actv8" src={actv8Logo} alt="actv8_logo"/>
                      <div>
                        <Button onClick={this.goBackHandler} btnText={'Go Back To Offer'}></Button>
                      </div>
                    </div>
  
                  </div>
                  : contentDetails
                }
              </div>
            )}
          </div>)
        }
      </div>
    );
  }
}

export default withCookies(withRouter(App));
